/**
 * PortalEvent - Event Bus
 */
/* globals $ */

const {log} = require('./PortalLogging')

const _eventNames = new Set()
const _bus = $({})

module.exports = class PortalEvent {

  static register(eventName) {
    log(`Registered event '${eventName}'`)
    _eventNames.add(eventName)
  }

  static emit(eventName, ...args) {
    if (!_eventNames.has(eventName))
      throw new Error(`No such event registered: ${eventName}`)
    log(`Triggering '${eventName}'`, args)
    _bus.trigger(eventName, args)
  }

  static on(eventName, handler) {
    if (!_eventNames.has(eventName))
      throw new Error(`No such event registered: ${eventName}`)
    log(`Registering handler for '${eventName}'`, handler)
    _bus.on(eventName, handler)
  }

  static once(eventName, handler) {
    if (!_eventNames.has(eventName))
      throw new Error(`No such event registered: ${eventName}`)
    _bus.one(eventName, handler)
  }
}



//////////////////
// WEBPACK FOOTER
// ./js/PortalEvent.js
// module id = 2
// module chunks = 0